import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDollarHandIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="#000"
      d="M14 9.2h-2.138v-.641h1.502V.64H.636v7.918h8.795v.64H0V0h14zM5.18 6.757v-.64h2.125a.6.6 0 0 0 .592-.602.594.594 0 0 0-.592-.596H6.67a1.23 1.23 0 0 1-1.228-1.236c0-.683.55-1.237 1.228-1.237h2.126v.64H6.669a.594.594 0 0 0-.592.597c0 .329.265.595.592.595h.636c.68 0 1.232.555 1.232 1.24s-.551 1.24-1.232 1.24zm2.138-3.99h-.636V1.543h.636zm0 4.887h-.636V6.438h.636zM10.872 14l-.45-.453a3.83 3.83 0 0 0 1.122-2.716v-.012.001-2.562a.9.9 0 0 0-.898-.899.9.9 0 0 0-.897.903V10.3l-.303.153a1.66 1.66 0 0 0-.912 1.483v.006h-.637v-.007c0-.875.487-1.636 1.204-2.023l.012-.006V8.262c0-.852.686-1.544 1.533-1.544.845 0 1.53.687 1.534 1.536v2.578c0 1.238-.5 2.359-1.308 3.168m-5.313-.02a4.47 4.47 0 0 1-1.308-3.167V8.879h.636v1.932c0 1.062.43 2.022 1.122 2.716z"
    />
  </svg>
);
export default SvgDollarHandIcon;
